import axios from "axios";
import API_BASE_URL from '../../config';

export const GetCoursesUserServices = async (token, idUser) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const responseCoursesUser = await axios.get(`${ API_BASE_URL }api/get-courses-user/`,
      
      {
        params: {
          user_id: idUser,
        },
        headers: {
            Authorization: `Bearer ${token}`,
        }
      }
    )
  
    console.log(responseCoursesUser.data)
    return responseCoursesUser.data;


    } catch (error) {
      console.error('Error en la solicitud:', error.response ? error.response.data : error.message);
      throw error;
    }
};